export default () => {
    return (
        <div className="level">
            <div className="top">
                <div className="lore">
                    <span className="diamond">Diamond</span>
                    Vip Level
                </div>
                <div className="amount">
                    <span>$2,500.00</span>
                    Deposits in 14 days
                </div>
            </div>
            <div className="benefits">
                <div></div>
                <span>AVAILABLE BENEFITS</span>
                <div></div>
            </div>
            <div className="benefits-list" data-benefits="2">
                <div className="benefit">
                    <div className="emoji">
                        💰
                    </div>
                    <div className="details">
                        <div className="name">Cashback</div>
                        <div className="value">10%</div>
                    </div>
                </div>

                <div className="benefit">
                    <div className="emoji">
                    🎁
                    </div>
                    <div className="details">
                        <div className="name">Redeemable Freeplays</div>
                    </div>
                </div>

                <div className="benefit">
                    <div className="emoji">
                    🎁
                    </div>
                    <div className="details">
                        <div className="name">Deposits</div>
                        <div className="value">+15%</div>
                    </div>
                </div>
            </div>
            <div className="benefits-list" data-benefits="2">
                <div className="benefit">
                    <div className="emoji">
                        👨‍💻
                    </div>
                    <div className="details">
                        <div className="name">Personal Bonuses</div>
                        <div className="value">Yes</div>
                    </div>
                </div>
                <div className="benefit">
                    <div className="emoji">
                        📈
                    </div>
                    <div className="details">
                        <div className="name">Balance Bonus</div>
                        <div className="value"><span>1.2%</span> day</div>
                    </div>
                </div>
            </div>
        </div>
    )
}